import { render, staticRenderFns } from "./select-learning-field.vue?vue&type=template&id=4faa7d7e&"
import script from "./select-learning-field.vue?vue&type=script&lang=js&"
export * from "./select-learning-field.vue?vue&type=script&lang=js&"
import style0 from "./select-learning-field.vue?vue&type=style&index=0&id=4faa7d7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports